import React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';

import { Input } from '@material-tailwind/react';

import { v4 as uuidv4 } from 'uuid';
import { mintCheck } from '../util/api';
import { useNavigate } from 'react-router-dom';
import data from '../assets/metadata.json';

export default function Explorer({ isMaintenance }) {
  const navigate = useNavigate();

  if (isMaintenance) {
    navigate('/maintenance');
  }

  const [number, setNumber] = useState(0);
  const [imgSrc, setImgSrc] = useState('');
  const [attributes, setAttributes] = useState([]);
  const [address, setAddress] = useState('');
  const [inscriptionId, setInscriptionId] = useState('');
  const [mintStatus, setMintStatus] = useState(false);

  useEffect(() => {
    fetchData(number);
  }, [number]);

  const handleNumber = (e) => {
    setNumber(e.target.value);
    debouncedSearch(e.target.value);
  };

  const debouncedSearch = useCallback(
    debounce(async (value) => {
      await fetchData(value);
    }, 500),
    []
  );

  const fetchData = async (value) => {
    let res = await mintCheck(value);
    if (res.status == 'success' && data[value]?.attributes != undefined) {
      setAttributes(data[value].attributes);
      setImgSrc('https://eyes4384.com/images/' + value + '.webp');
      setInscriptionId(res.data.inscriptionId);
      setAddress(res.data.receiveAddress);
      setMintStatus(true);
    } else {
      setAttributes([]);
      setImgSrc('https://eyes4384.com/images/blank.png');
      setInscriptionId('');
      setAddress('');
      setMintStatus(false);
    }
  };

  const formatInscriptionId = (value) => {
    if (value == '' || value == undefined) return '-';
    return value.substring(0, 6) + '...' + value.substring(value.length - 6);
  };

  return (
    <div className='flex sm:flex-row flex-col sm:gap-8 gap-4 mt-[100px] z-[9999]'>
      <div className='flex flex-col sm:min-w-[500px] min-w-[350px] sm:gap-3 gap-2'>
        <div className='flex sm:hidden flex-row-reverse'>
          <div
            className='font-bold text-red-800 text-[20px] underline cursor-pointer'
            onClick={() => navigate('/')}
          >
            HOME
          </div>
        </div>
        <div className='text-white font-bold text-[24px]'>
          Please insert number
        </div>
        <div className='max-w-[300px]'>
          <Input
            type='text'
            color='white'
            label='Insert number'
            className='w-full min-w-[300px]'
            value={number}
            onChange={handleNumber}
          />
        </div>
        <div className='sm:w-[500px] sm:h-[500px] w-[350px] h-[350px] border-[2px] rounded-md border-gray-800 border-solid'>
          <img src={imgSrc} className='h-full w-full object-cover' />
        </div>
      </div>
      <div className='flex flex-col sm:min-w-[500px] min-w-[350px] gap-3 sm:mt-[100px] mt-1'>
        <div className='flex flex-col bg-gray-800 rounded-md text-white p-4 gap-3'>
          <div className='text-center w-full text-white font-bold text-[24px]'>
            Details
          </div>
          <div className='flex flex-row gap-2'>
            <span className='font-bold text-white text-[18px]'>
              Inscription Id:
            </span>
            <a
              href={`https://ordinals.com/inscription/${inscriptionId}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='font-bold text-red-800 text-[18px] cursor-pointer'>
                {formatInscriptionId(inscriptionId)}
              </span>
            </a>
          </div>
          <div className='flex flex-row gap-2'>
            <span className='font-bold text-white text-[18px]'>
              Owner Address:
            </span>
            <span className='font-bold text-red-800 text-[18px]'>
              {formatInscriptionId(address)}
            </span>
          </div>
          <div className='flex flex-row gap-2'>
            <span className='font-bold text-white text-[18px]'>
              Mint Status:
            </span>
            <span className='font-bold text-red-800 text-[18px]'>
              {mintStatus ? 'Minted' : 'Not Minted'}
            </span>
          </div>
        </div>
        <div className='flex flex-col bg-gray-800 rounded-md text-white p-4 gap-3'>
          <div className='text-center w-full text-white font-bold text-[24px]'>
            Attributes
          </div>
          {attributes.map((data) => (
            <div className='flex flex-row gap-2' key={uuidv4()}>
              <span className='font-bold text-white text-[18px]'>
                {data.trait_type}:
              </span>
              <span className='font-bold text-white text-[18px]'>
                {data.value}
              </span>
            </div>
          ))}
        </div>
        <div className='sm:flex hidden flex-row-reverse'>
          <div
            className='font-bold text-red-800 text-[20px] underline cursor-pointer'
            onClick={() => navigate('/')}
          >
            HOME
          </div>
        </div>
      </div>
    </div>
  );
}
